import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AppAuthProvider } from './auth/AppAuthProvider';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.REACT_APP_BASENAME || '/'}>
      <AppAuthProvider>
        <App />
      </AppAuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);